import React from "react";

const DashboardCalendarDay = ({ day, eventosDelDia = [], onDayClick  }) => {
  const hasEvents = eventosDelDia.length > 0;
  const defaultColors = ["#3498db", "#e74c3c", "#f1c40f", "#8e44ad"];
  const eventColor = hasEvents
    ? defaultColors[Math.floor(Math.random() * defaultColors.length)]
    : "transparent";
  
  const handleClick = () => {
    if (onDayClick) {
      onDayClick(); // Redirige solo si hay eventos o días disponibles.
    }
  };

  return (
    <div onClick={handleClick} className="h-12 w-12 sm:h-16 sm:w-16 flex items-center justify-center relative cursor-pointer">
      <div
        className={`h-8 w-8 sm:h-10 sm:w-10 flex items-center justify-center rounded-full font-bold ${
          hasEvents ? "text-white" : "text-gray-700"
        }`}
        style={{
          backgroundColor: hasEvents ? eventColor : "transparent",
        }}
      >
        {day}
      </div>

      {hasEvents && (
        <div
          className="absolute bottom-0 h-1 w-full rounded"
          style={{ backgroundColor: eventColor }}
        ></div>
      )}
    </div>
  );
};

export default DashboardCalendarDay;